import { render, staticRenderFns } from "./WhatIfResearchOutputReview.vue?vue&type=template&id=5167fe68&scoped=true&"
import script from "./WhatIfResearchOutputReview.vue?vue&type=script&lang=js&"
export * from "./WhatIfResearchOutputReview.vue?vue&type=script&lang=js&"
import style0 from "./WhatIfResearchOutputReview.vue?vue&type=style&index=0&id=5167fe68&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5167fe68",
  null
  
)

export default component.exports